module.exports = __webpack_public_path__ + "img/roll_l_a.df1e81e5.png";